import {useQuery} from '@tanstack/react-query'

import {QueryKeyName, getQuestions} from '../../common/backend'
import {usePlantUpmId} from '../usePlantUpmIdContext'
import {useTopicId} from '../urlParameters/useTopicId'

export const useQuestions = () => {
  const plantId = usePlantUpmId()
  const topicId = useTopicId()

  return useQuery({
    queryKey: [QueryKeyName.GetQuestions, plantId, topicId],
    queryFn: () => getQuestions({plantId, topicId})
  })
}
